export default {
    title: 'Competency Assessment',
    description:
        'Prepare the assessment quiz for your employee. This assessment is to be completed exclusively by you, as the {{managerLabel}}.',
    searchEmployee: 'Search for Employees by name',
    noEmployeesFound: 'No employees found.',
    employeeHasNoCompetencyProfile: 'This employee does not have a competency profile.',
    assignCompetencyProfile: 'Click here to assign a competency profile',
    deselectEmployee: 'Deselect employee',
    selectEmployee: 'Select Employee to Assess',
    chooseSkills: 'Choose Competencies to Assess',
    skillOptions: {
        all: 'All competencies',
        allDesc: 'Assess all available competencies for comprehensive assessment',
        weakest: 'Weakest competencies',
        weakestDesc: 'Focus on competencies that need improvement',
        old: '6 Months and Older',
        oldDesc: 'Competencies without any assessment during the last six months',
        skillCount: '({{count}} competencies)',
    },
    or: 'Or',
    methods: {
        custom: 'Select competencies to assess',
        customDesc:
            "Choose individual competencies from your organization's competency library to create a custom assessment.",
        template: 'Use an assessment template',
        templateDesc:
            'Start with a pre-built assessment template that contains competencies associated with a competency profile.',
    },
    selectTemplate: 'Select a Template',
    noSurveyNote: 'This review will only be completed by you. Employees will not receive a survey.',
    reviewSkills: 'Review assessed competencies',
    estimatedTime: 'Estimated completion time: 12 minutes',
    addSkillsToAssess: 'Add Competencies to Assess',
    competencyCount: '{{count}} competencies',
    competencyCount_one: '{{count}} competency',
    competencyCount_other: '{{count}} competencies',
    questionCount: '{{count}} questions',
    questionCount_one: '{{count}} question',
    questionCount_other: '{{count}} questions',
    addSkillsModal: {
        title: 'Add Competencies to Assessment',
        searchPlaceholder: 'Search competencies...',
        noSkills: 'No competencies found',
        selectedCount: '{{count}} competencies selected',
        cancel: 'Cancel',
        addSelected: 'Add Selected Competencies',
        alreadyAdded: 'Already added',
    },
    companyValues: {
        title: 'Assess Adherence to Company Values',
        description:
            'You can choose to evaluate company values in the assessment survey. Questions related to company values appear after the competencies questions.',
        include: 'Include company values questions in the survey',
        noValues: 'No company values have been configured. Add them from the Vision page.',
    },
    startAssessment: 'Start the Review',
    startAssessmentDesc:
        'Click "Start the Review" to begin the assessment process. You will be redirected to the Assessment page, where you can review or answer the assessment questions. Use this feature to start collecting feedback, measure progress, and gain insights into competency development.',
    ungrouped: 'Other',
    selectedCount: '{{count}} of {{total}} selected',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    noCompetenciesFound: 'No competencies found for this employee.',
    status: {
        not_met: 'Not Met',
        in_evolution: 'In Evolution',
        almost_achieved: 'Almost Achieved',
        achieved: 'Achieved',
    },
    evaluationPeriod: {
        annual: 'Annual assessment',
        firstHalf: 'First half',
        secondHalf: 'Second half',
    },
};
